import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';

export default function PatientAge(props) {
  const {
    patient,
  } = props || {};
  const {
    age,
  } = patient;
  return (
    <div {...ex('PatientAge', props)}>
      {T('만 {0}세', age)}
    </div>
  );
}
